export const GPU_COMPUTE_POWER: { [key: string]: number } = {
  "GB200": 6400.0,
  "B200": 900.0,
  "H200": 840.0,
  "H100": 600.0,
  "H800": 405.0,
  "A800": 405.0,
  "A100": 159.0,
  "L20": 45.0,
  "RTX4090": 31.5,
  "RTX5090": 43.5
}

export interface Flavor {
  name: string
  gpu_type: string
  gpu_number: number
  stock_quantity: number
  monthly_fee: string
}

export interface TierData {
  highest_total_stock_gpu_type_flavors: Flavor[]
  cheapest_monthly_fee_flavor?: Flavor
  highest_stock_flavor?: Flavor
}

export interface GpuStatistics {
  content: {
    advanced: TierData
    intermediate: TierData
  }
}

export interface ParsedInput {
  X: number
  Y: number
}

export interface FlavorResult {
  name: string
  gpu_type: string
  gpu_number: number
  stock_quantity: number
  training_days: number
  training_time_display: string
  total_cost: number
}

export interface ProcessedTierResult {
  "Cheapest Flavor": FlavorResult
  "Fastest Flavor": FlavorResult
}

export interface GpuTrainingResults {
  "Advanced Tier": ProcessedTierResult
  "Intermediate Tier": ProcessedTierResult
}

export interface Message {
  content: string
  type: 'user' | 'assistant'
  timestamp: Date
  gpuResults?: GpuTrainingResults
  aiResults?: GpuAiResult[]
  messageKey?: string
  messageParams?: any
  formStep?: string
  awaitingInput?: boolean
}

export interface GpuAiResult {
  product_id: number
  name: string
  gpu_type: string
  gpu_number: number
  stock_quantity: number
  training_hours: number
  total_cost: number
  calculate_result: 'first' | 'second' | 'third' | 'cheapest'
  promote?:boolean
  billing_type: 'hour' | 'month'
  tokens_per_hour?: number
  total_tokens?: number
}

export interface BudgetInfo {
  reduction_ratio: number
  current_budget: number
  required_budget: number
}

export interface GpuAiResponse {
  status_code: 1 | 2 | 3 | 4
  messageKey: string  // i18n 翻譯鍵，前端根據語言自動顯示
  gpuResults?: GpuAiResult[]
  budget_info?: BudgetInfo
  messageParams?: Record<string, any>  // 翻譯所需的參數
}